
import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "agreement";

const nameSpace = merge({}, generateEndpoints(namespace), {
    get: {
        getList: ({platformId, kind}) => [`${prefix}/profile/${namespace}/${kind}`]
    },
    post: {
      subscribe: (agreementId) => [`${prefix}/profile/${namespace}/subscribe/${agreementId}`, {agreementId: agreementId}],
  },
})

export default nameSpace;
